// constants/testIds/zita.js — data-testid registry for Zita UI.
// Naming: kebab-case, `<feature>-<element>-<qualifier>`.

export const AUTH = {
	registerEmail: 'auth-register-email',
	registerPassword: 'auth-register-password',
	registerName: 'auth-register-name',
	registerUsername: 'auth-register-username',
	registerSubmit: 'auth-register-submit',
	loginEmail: 'auth-login-email',
	loginPassword: 'auth-login-password',
	loginRemember: 'auth-login-remember',
	loginSubmit: 'auth-login-submit',
	forgotEmail: 'auth-forgot-email',
	forgotSubmit: 'auth-forgot-submit',
	resetPassword: 'auth-reset-password',
	resetSubmit: 'auth-reset-submit',
	verifySubmit: 'auth-verify-submit',
	logoutButton: 'auth-logout-button',
	changePwCurrent: 'auth-change-pw-current',
	changePwNew: 'auth-change-pw-new',
	changePwConfirm: 'auth-change-pw-confirm',
	changePwSubmit: 'auth-change-pw-submit',
	subscribeCta: 'subscribe-cta',
	subscribeUpdateCardCta: 'subscribe-update-card-cta',
};

export const NAV = {
	brand: 'nav-brand',
	home: 'nav-home',
	seek: 'nav-seek',
	alerts: 'nav-alerts',
	vault: 'nav-vault',
	connect: 'nav-connect',
	history: 'nav-history',
	settings: 'nav-settings',
	billing: 'nav-billing',
	ariButton: 'nav-ari-button',
};

export const SEEK = {
	commandBar: 'seek-command-bar',
	interpretedBox: 'seek-interpreted-box',
	editInterpretation: 'seek-edit-interpretation',
	confirmSearch: 'seek-confirm-search',
	scanAllButton: 'seek-scan-all-button',
	voiceButton: 'seek-voice-button',
	filterToggle: 'seek-filter-toggle',
	maxPriceInput: 'seek-max-price',
	freeOnlyToggle: 'seek-free-only',
	radiusInput: 'seek-radius',
	locationInput: 'seek-location',
	suggestionChip: 'seek-suggestion-chip',
};

export const SCAN = {
	progressList: 'scan-progress-list',
	sourceRow: 'scan-source-row',
	statusBadge: 'scan-status-badge',
	viewResults: 'scan-view-results',
};

export const RESULTS = {
	groupBySource: 'results-group-by-source',
	viewCombined: 'results-view-combined',
	sortSelect: 'results-sort-select',
	sourceGroup: 'results-source-group',
	listingCard: 'results-listing-card',
	openListing: 'results-open-listing',
	saveListing: 'results-save-listing',
	dismissListing: 'results-dismiss-listing',
	opportunityBadge: 'results-opportunity-badge',
	analysisToggle: 'results-analysis-toggle',
	opportunityCard: 'results-opportunity-card',
};

export const SOURCES = {
	list: 'sources-list',
	card: 'sources-card',
	toggle: 'sources-toggle',
	extensionInstall: 'sources-extension-install',
	extensionPair: 'sources-extension-pair',
	pairingCode: 'sources-pairing-code',
};

export const VAULT = {
	list: 'vault-list',
	item: 'vault-item',
	statusSelect: 'vault-status-select',
	deleteButton: 'vault-delete-button',
	buyerCard: 'vault-buyer-card',
	buyerSaveButton: 'vault-buyer-save-button',
};

export const BILLING = {
	monthlyCard: 'billing-monthly-card',
	annualCard: 'billing-annual-card',
	startTrialButton: 'billing-start-trial-button',
	portalButton: 'billing-portal-button',
	planName: 'billing-plan-name',
};

export const ARI = {
	panel: 'ari-panel',
	openButton: 'ari-open-button',
	closeButton: 'ari-close-button',
	messages: 'ari-messages',
	input: 'ari-input',
	send: 'ari-send',
	mic: 'ari-mic',
	voiceMessage: 'ari-voice-message',
	playTts: 'ari-play-tts',
};

export const HOME_PAGE = {
	hero: 'home-hero',
	getStarted: 'home-get-started',
	loginLink: 'home-login-link',
};

export const FOOTER = {
	root: 'public-footer',
	about: 'public-footer-about',
	privacy: 'public-footer-privacy',
	terms: 'public-footer-terms',
	support: 'public-footer-support',
};
